import { render } from "./ComboFormaAtivacaoClientes.vue?vue&type=template&id=403e030c&ts=true"
import script from "./ComboFormaAtivacaoClientes.vue?vue&type=script&lang=ts"
export * from "./ComboFormaAtivacaoClientes.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\OnSeller\\FrontEnd\\Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__